import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const totalNumberForm: Form<Client> = {
  key: 'totalNumber',
  fields: [
    {
      key: 'totalNumber',
      label: 'Gesamtzahl',
      fieldTypes: 'text',
    },
  ],
};

export default totalNumberForm;
